/**
 * Toggle a quick-filter chip: set field→value, or clear if already active.
 * activeFilters must stay a plain { field: value } map (never store filter config / React nodes).
 */
export const toggleQuickFilter = (activeFilters, filter) => {
  const field = filter?.field || filter?.type;
  const value = filter?.value;
  if (!field) return activeFilters || {};

  const next = { ...(activeFilters || {}) };
  if (next[field] === value) {
    delete next[field];
  } else {
    next[field] = value;
  }
  return next;
};

/** Strip non-JSON-serializable values before persisting filter state. */
export const sanitizeFiltersForStorage = (filters) => {
  if (!filters || typeof filters !== 'object') return {};
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => {
      const t = typeof value;
      return value === null || t === 'string' || t === 'number' || t === 'boolean';
    })
  );
};
